import { render, staticRenderFns } from "./insPrivilege.vue?vue&type=template&id=39948d90&"
import script from "./insPrivilege.vue?vue&type=script&lang=js&"
export * from "./insPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports